export default {
  nav: {
    onlineSms: 'Online SMS',
    rentNumber: 'Softwareentwicklung',
    esim: 'Lotterie',
    apiConnection: 'API',
    agent: 'Live-Chat',
    blog: 'Teilen',
    help: 'Hilfe',
    register: 'Registrieren',
    login: 'Anmelden'
  },
  header: {
    memberCenter: 'Mitgliederbereich',
    logout: 'Abmelden',
    logoutSuccess: 'Erfolgreich abgemeldet'
  },
  common: {
    user: 'Benutzer',
    chinese: 'Chinesisch',
    loading: 'Laden...',
    noData: 'Keine Daten',
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    save: 'Speichern',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    back: 'Zurück',
    submit: 'Absenden',
    search: 'Suchen',
    success: 'Erfolg',
    error: 'Fehler',
    warning: 'Warnung',
    info: 'Info',
    copySuccess: 'Erfolgreich kopiert',
    copyFailed: 'Kopieren fehlgeschlagen',
    operationSuccess: 'Vorgang erfolgreich',
    operationFailed: 'Vorgang fehlgeschlagen',
    networkError: 'Netzwerkfehler, bitte versuchen Sie es später erneut',
    payWith: 'Bezahlen mit',
    unit: '',
    yes: 'Ja',
    no: 'Nein',
    all: 'Alle',
    more: 'Mehr',
    next: 'Weiter',
    prev: 'Zurück'
  },
  home: {
    title: 'SMS-Empfangsplattform',
    subtitle: 'Registrieren Sie sich bei sozialen Netzwerken und Online-Shops ohne Spam oder Offenlegung persönlicher Daten.',
    btnGetNumber: 'Nummer erhalten',
    btnRent: 'Mieten',
    phoneCount: '1000+',
    sectionTitle: 'SMS-MAN — Telefonnummern für SMS-Empfang mieten',
    sectionDesc: 'Mit SMS-MAN können Sie eine virtuelle Nummer mieten und SMS aus über 200 Ländern empfangen. Mietdauer: 24 Stunden, eine Woche oder ein Monat.',
    sectionDesc2: 'Es ist sehr praktisch, wenn Sie sich bei vielen Online-Anwendungen mit einer angegebenen Telefonnummer registrieren müssen. Wenn die Nummer nicht passt (keine SMS erhalten), können Sie sie innerhalb von 20 Minuten kostenlos stornieren!',
    howItWorks: 'So funktioniert es',
    stepsTitle: 'Virtuelle Nummer in 3 Schritten mieten',
    step1Title: 'Land auswählen',
    step2Title: 'Mietdauer festlegen',
    step3Title: 'Nummer mieten',
    step1Desc: 'Indien, Mexiko, Israel',
    step2Desc: 'Stunde, Tag, Woche, Monat',
    step3Desc: 'Mietdauer',
    whyChoose: 'Warum SMS-MAN wählen',
    feature1Title: 'Einmalige Nummer kaufen oder bis zu einem Monat mieten',
    feature2Title: 'Einmalige Nummer für SMS-Empfang',
    feature2Desc: 'Wählen Sie einen Dienst oder alle Dienste, um SMS über eine virtuelle Nummer zu empfangen.',
    feature3Title: 'Nummer mieten',
    feature3Desc: 'Mieten Sie eine Telefonnummer und empfangen Sie unbegrenzt SMS von jeder Website oder Anwendung.',
    usageLimit: 'Nutzungslimit',
    usageLimitDesc: 'Bis zu 20 Minuten',
    usageLimitDesc2: 'Bis zu 30 Tage',
    youCanReceive: 'Sie können SMS empfangen',
    youCanReceiveDesc: 'Von einer beim Kauf ausgewählten Website/App unbegrenzt',
    youCanReceiveDesc2: 'Alle verfügbaren Dienste',
    serviceCount: '200+',
    serviceCount2: '16',
    countryCount: '1000+',
    countryCount2: 'Alle verfügbaren Dienste',
    btnRentNow: 'Jetzt mieten',
    btnRentNumber: 'Nummer mieten',
    aboutText: '"SMS-Man" ermöglicht es Ihnen, eine virtuelle Nummer für SMS-Empfang zu erstellen.',
    aboutText2: 'Viele Websites erfordern SMS-Verifizierung. Diese Dienste sind mit ausländischen Telefonnummern normalerweise nicht verfügbar.',
    aboutText3: 'SMS-MAN bietet Dienste in über 200 Ländern/Regionen an.',
    aboutText4: 'Es gibt viele Vorteile beim Mieten von Nummern auf "SMS-Man":',
    aboutText5: 'Eine virtuelle Nummer kann für die Registrierung bei 200+ Websites verwendet werden.',
    aboutText6: 'Sie müssen sich keine Sorgen um die Offenlegung Ihrer persönlichen Telefonnummer machen.',
    aboutText7: 'Verwalten Sie Nummern aus verschiedenen Ländern auf einer Plattform.',
    aboutText8: 'Keine Fachkenntnisse nötig, sehr günstig.',
    aboutText9: 'Mieten Sie jederzeit online eine Telefonnummer!',
    registerTitle: 'Registrieren',
    registerDesc: 'Keine persönlichen Daten nötig, nur 3 Schritte',
    regStep1: 'E-Mail auf der Website eingeben',
    regStep1Desc: 'Geben Sie Ihre E-Mail-Adresse ein und erstellen Sie ein Passwort.',
    regStep2: 'E-Mail im Postfach bestätigen',
    regStep2Desc: 'Wir haben eine Bestätigungs-E-Mail gesendet. Bitte öffnen Sie die E-Mail und klicken Sie auf den Bestätigungslink.',
    regStep3: 'Herzlichen Glückwunsch! Sie sind registriert',
    regStep3Desc: 'Sie können sich jetzt anmelden und alle SMS-MAN Dienste nutzen.',
    onlineServiceTitle: 'Bequemer Online-SMS-Empfangsdienst',
    joinTelegram: 'Online-Chat beitreten',
    joinTelegramDesc: 'Treten Sie unserer Telegram-Gruppe bei für die neuesten Nachrichten',
    telegramBot: 'Telegram-Bot',
    telegramBotDesc: 'SMS über Telegram-Bot empfangen',
    userGroup: 'Benutzergruppe',
    userGroupDesc: 'Benutzergruppe beitreten für Hilfe',
    desktopApp: 'Desktop-Anwendung',
    desktopAppDesc: 'Desktop-Anwendung herunterladen',
    btnJoin: 'Beitreten',
    btnConnect: 'Verbinden',
    btnDownload: 'Herunterladen',
    professionalTitle: 'Lösung für Profis',
    professionalDesc: 'SMS-MAN bietet nicht nur bequeme Tools für normale Benutzer, sondern auch für Profis.',
    apiConnect: 'API-Verbindung',
    apiConnectDesc: 'SMS empfangen und senden, Ihre Arbeit automatisieren',
    readMore: 'Weiterlesen',
    faqTitle: 'FAQ',
    faq1: 'Was ist der SMS-Plattformdienst? Wie funktioniert er?',
    faq2: 'Was ist SMS-MAN?',
    faq3: 'Brauche ich eine Einweg-SIM-Karte für SMS-Empfang?',
    faq4: 'Sind private Daten bei SMS-MAN sicher?',
    faq5: 'Wie bestätige ich den SMS-Empfangserfolg?',
    faq6: 'Ist die SMS-Plattform wirklich sicher?',
    faq7: 'Warum SMS-Man für SMS-Empfang wählen?',
    footer: {
      smsPlatform: 'SMS-Plattform',
      rentNumber: 'Nummer mieten',
      apiConnection: 'API',
      referral: 'Empfehlung',
      partnership: 'Partnerschaft',
      partners: 'Partner',
      blog: 'Teilen',
      help: 'Hilfe',
      privacyPolicy: 'Datenschutzrichtlinie',
      termsOfUse: 'Nutzungsbedingungen',
      paymentRefund: 'Zahlung & Rückerstattung',
      companyInfo: 'VtoTop Company Limited',
      address: 'Room B, 10/F, Yue Cheong Building, 38 Des Voeux Road Central, Central, Hong Kong',
      email: 'vtoptopcom@gmail.com'
    }
  },
  login: {
    title: 'Anmelden',
    email: 'E-Mail',
    password: 'Passwort',
    emailPlaceholder: 'E-Mail eingeben',
    passwordPlaceholder: 'Passwort eingeben',
    forgotPassword: 'Passwort vergessen?',
    noAccount: 'Noch kein Konto?',
    register: 'Registrieren',
    socialLogin: 'Oder mit Social-Plattform anmelden',
    btnLogin: 'Anmelden',
    captchaSuccess: 'Erfolgreich!',
    loginFailed: 'Anmeldung fehlgeschlagen'
  },
  register: {
      title: 'Registrieren',
      email: 'E-Mail eingeben',
      codePlaceholder: 'Bestätigungscode eingeben',
      sendCode: 'Code anfordern',
      sending: 'Wird gesendet...',
      codeSent: 'Code gesendet, bitte E-Mail prüfen',
      password: 'Passwort erstellen',
      confirmPassword: 'Passwort bestätigen',
      agreeTerms: 'Mit der Registrierung stimmen Sie zu',
      terms: 'Nutzungsbedingungen',
      hasAccount: 'Bereits ein Konto?',
      login: 'Anmelden',
      socialLogin: 'Oder mit sozialem Konto anmelden',
      btnRegister: 'Registrieren',
      registering: 'Registrierung...',
      captchaSuccess: 'Erfolgreich!',
      passwordMismatch: 'Passwörter stimmen nicht überein',
      registerFailed: 'Registrierung fehlgeschlagen',
      codeExpired: 'Code abgelaufen, bitte neu anfordern',
      codeError: 'Ungültiger Bestätigungscode'
    },
  member: {
    sidebar: {
      receiveSms: 'SMS empfangen',
      premiumSms: 'Premium SMS',
      rentNumber: 'Nummer mieten',
      esim: 'eSIM',
      proxyMan: 'Proxy Man',
      recharge: 'Aufladen',
      loyalty: 'Treueprogramm',
      earn: 'Verdienen',
      partnership: 'Partnerschaft',
      api: 'API',
      instructions: 'Anleitung',
      feedback: 'Feedback',
      help: 'Hilfe',
      chatGroup: 'Live-Chat',
      chatManage: 'Chat-Verwaltung',
      receptionRecords: 'Empfangsdaten',
      chatPlan: 'Chat-Tarif',
	  chatSettings: 'Chat-Einstellungen',
      lotteryGroup: 'Lotterie',
      lotteryBets: 'Wetteinträge'
    },
    header: {
      desktopClient: 'Desktop-Client',
      desktopClientDesc: 'SMS direkt auf dem Computer empfangen',
      telegramBot: 'Telegram-Bot',
      telegramBotDesc: 'SMS direkt auf Telegram empfangen',
      try: 'Ausprobieren',
      connect: 'Verbinden',
      balance: 'Guthaben',
      recharge: 'Aufladen',
      language: 'Sprache'
    },
    avatarMenu: {
      settings: 'Einstellungen',
      profile: 'Profil anzeigen',
      logout: 'Abmelden'
    },
    receiveSms: {
      title: 'SMS empfangen',
      selectService: 'Dienst auswählen',
      searchService: 'Nach Dienst suchen',
      selectCountry: 'Land auswählen',
      searchCountry: 'Nach Land suchen',
      sort: 'Sortieren',
      buySms: 'SMS kaufen',
      doubleSms: 'Doppelte SMS',
      btnBuySms: 'SMS kaufen'
    },
    premiumSms: {
      title: 'Premium SMS',
      selectService: 'Dienst auswählen',
      searchService: 'Nach Dienst suchen',
      selectCountry: 'Land auswählen',
      searchCountry: 'Nach Land suchen',
      sort: 'Sortieren',
      buySms: 'SMS kaufen',
      doubleSms: 'Doppelte SMS',
      btnBuySms: 'SMS kaufen'
    },
    rentNumber: {
      title: 'Nummer mieten',
      subtitle: 'Nur für SMS-Empfang',
      wholeNumber: 'Ganze Nummer',
      byService: 'Nach Dienst',
      selectCountry: '1. Land auswählen',
      search: 'Suchen',
      setDuration: '2. Dauer festlegen',
      hour: 'Stunde',
      day: 'Tag',
      week: 'Woche',
      month: 'Monat',
      rentNumber: '3. Nummer mieten',
      cost: 'Kosten',
      btnRent: 'Mieten',
      rentDesc: 'Sie bezahlen für die Nummer und ihre Mietdauer. Während des gewählten Zeitraums können Sie unbegrenzt SMS empfangen.',
      premiumTitle: 'Premium-Nummer',
      premiumDesc: 'Zugang zu hochwertigen Nummern mit höheren Zustellraten',
      btnPremium: 'Premium erhalten'
    },
    esim: {
      title: 'eSIM',
      selectCountry: '1. Land/Region auswählen',
      searchCountry: 'Land oder Region suchen',
      all: 'Alle',
      mixed: 'Gemischt',
      showAll: 'Alle anzeigen',
      selectPlan: '2. Tarif auswählen',
      esimInfo: 'eSIM wird sofort nach der Zahlung aktiviert.',
      phoneSupport: 'Unterstützt Ihr Telefon eSIM?',
      phoneSupportDesc: 'Wählen Sie *#06#, wenn EID angezeigt wird, unterstützt das Gerät eSIM.',
      howToConfig: 'Mobile Daten über eSIM konfigurieren',
      selectType: '3. eSIM-Typ auswählen',
      allType: 'Alle',
      dataOnly: 'Nur Daten',
      dataAndCall: 'Daten + Anrufe',
      btnRecharge: 'Aufladen'
    },
    recharge: {
      title: 'Guthaben aufladen',
      payMethod: 'Zahlungsmethode',
      usdtDesc: 'Aufladung über USDT TRC-20, nach Admin-Bestätigung gutgeschrieben',
      onlyUsdt: 'Nur USDT',
      fillAmount: 'Aufladungsbetrag',
      otherAmount: 'Benutzerdefinierter Betrag',
      btnPay: 'Jetzt aufladen',
      submitting: 'Senden...',
      payDesc: 'USDT-Adresse und QR-Code werden nach der Bestellung angezeigt',
      invalidAmount: 'Bitte geben Sie einen gültigen Betrag ein (min. $1)',
      rechargeFailed: 'Aufladung fehlgeschlagen',
      rechargeFailedRetry: 'Aufladung fehlgeschlagen, bitte erneut versuchen',
      historyTitle: 'Aufladungsverlauf',
      thOrderNo: 'Bestellnr.',
      thAmount: 'Betrag',
      thStatus: 'Status',
      thTime: 'Zeit',
      statusPending: 'Ausstehend',
      statusPaid: 'Gutgeschrieben',
      statusCancelled: 'Storniert',
      scanToPay: 'QR-Code scannen',
      payAmount: 'Betrag',
      usdtAddress: 'USDT TRC-20 Adresse',
      copy: 'Kopieren',
      copied: 'Kopiert',
      orderNo: 'Bestellnr.',
      waitingConfirm: 'Warten auf Admin-Bestätigung, automatische Aktualisierung nach Zahlung',
      paySuccess: 'Aufladung gutgeschrieben',
      paySuccessDesc: 'Ihre Aufladung wurde erfolgreich gutgeschrieben'
    },
    feedback: {
      title: 'Kontaktieren Sie uns',
      name: 'Ihr Name',
      email: 'E-Mail',
      question: 'Ihre Frage',
      btnSend: 'Senden',
      captchaSuccess: 'Erfolgreich!',
      support247: '24/7 Online-Support',
      responseTime: 'Durchschnittliche Antwortzeit ca. 15 Minuten',
      weekendWork: 'Wochenend-Support wie gewohnt',
      chatSupport: 'Chat-Support',
      youtube: 'YouTube'
    },
    partnership: {
      title: 'Geld verdienen mit SIM-Karten',
      desc1: 'Wenn Sie Telefonnummern (SIM-Karten) haben, die für SMS-Empfang genutzt werden können.',
      desc2: 'Beginnen Sie mit SMS-Man SIM-Karten zu verdienen!',
      whatTogether: 'Was können wir zusammen tun?',
      whatTogetherDesc: 'SMS-Man ist eine internationale Plattform für Online-SMS-Empfang.',
      whatTogetherDesc2: 'Die Nachfrage unserer Kunden wächst schnell. Deshalb suchen wir Sie.',
      howContact: 'Wie kontaktiert man SMS-Man?',
      restApi: 'REST API',
      restApiDesc: 'Sie stellen uns API-Dateien und ein Direktzahlungskonto zur Verfügung.',
      gsmGoip: 'GSM/GoIP',
      gsmGoipDesc1: 'Sie haben GSM/GoIP-Ausrüstung',
      gsmGoipDesc2: 'Wir verbinden Sie mit spezieller Software',
      gsmGoipDesc3: 'Statistiken auf einem speziellen Dashboard verfolgen',
      gsmGoipDesc4: 'Einkommen hängt vom Land der SIM-Karte ab',
      apiLink: 'API-Link',
      apiLinkDesc1: 'Zum Beispiel, Sie haben Nummern in diesem Format:',
      apiLinkDesc2: 'Wir kaufen Nummern nach den Bedingungen'
    },
    instructions: {
      title: 'Facebook über SMS-MAN registrieren',
      step1: 'Schritt 1. Nummer erhalten.',
      step1Desc: 'Verwenden Sie eine einmalige',
      receiveSms: 'SMS empfangen',
      or: 'oder',
      rentNumber: 'Nummer mieten',
      step2: 'Schritt 2: Nummer kopieren.',
      step2Desc: 'Klicken Sie auf das Symbol oder wählen Sie die Nummer, drücken Sie Strg+C.',
      step3: 'Schritt 3. Facebook-Registrierung ausfüllen.',
      step3Desc: 'Gehen Sie zu facebook.com und klicken Sie auf "Neues Konto erstellen".'
    },
    loyalty: { title: 'Treueprogramm' },
    earn: { title: 'Verdienen' },
    api: { title: 'API-Dokumentation' },
    help: { title: 'Hilfecenter' },
    lotteryBets: {
      title: 'Wetteinträge',
      allTypes: 'Alle Typen',
      allResults: 'Alle Ergebnisse',
      win: 'Gewinn',
      lose: 'Verlust',
      pending: 'Ausstehend',
      searchPeriod: 'Zeitraum suchen...',
      totalBets: 'Gesamte Wetten',
      totalWin: 'Gewinn',
      totalLose: 'Verlust',
      totalPending: 'Ausstehend',
      totalProfit: 'Gesamt G/V',
      period: 'Zeitraum',
      lotteryType: 'Typ',
      playType: 'Spiel',
      betContent: 'Wettinhalt',
      betAmount: 'Betrag',
      odds: 'Quoten',
      drawNumbers: 'Ziehungsnummern',
      result: 'Ergebnis',
      profit: 'G/V',
      time: 'Zeit',
      totalRecords: '{0} Einträge',
      prevPage: 'Zurück',
      nextPage: 'Weiter'
    },
    profile: {
      title: 'Profil',
      pageDesc: 'Kontodetails anzeigen',
      userId: 'Benutzer-ID',
      balance: 'Guthaben',
      registerTime: 'Registrierungszeit',
      lastLogin: 'Letzte Anmeldung',
      accountStatus: 'Kontostatus',
      langSetting: 'Sprache',
      statusActive: 'Aktiv',
      statusInactive: 'Deaktiviert',
      apiInfo: 'API-Info',
      apiKey: 'API-Schlüssel',
      notGenerated: 'Nicht generiert',
      copy: 'Kopieren',
      usageStats: 'Nutzungsstatistiken',
      smsOrders: 'SMS-Bestellungen',
      rechargeCount: 'Aufladungen',
      totalSpent: 'Gesamtausgaben',
      chatSessions: 'Chat-Sitzungen'
    },
    settings: {
      title: 'Einstellungen',
      pageDesc: 'Konto und Sicherheit verwalten',
      changePassword: 'Passwort ändern',
      currentPassword: 'Aktuelles Passwort',
      currentPasswordPh: 'Aktuelles Passwort eingeben',
      newPassword: 'Neues Passwort',
      newPasswordPh: 'Neues Passwort eingeben (min. 6 Zeichen)',
      confirmNewPassword: 'Neues Passwort bestätigen',
      confirmNewPasswordPh: 'Neues Passwort erneut eingeben',
      saving: 'Speichern...',
      saveChanges: 'Änderungen speichern',
      changeEmail: 'E-Mail ändern',
      currentEmail: 'Aktuelle E-Mail',
      newEmail: 'Neue E-Mail',
      newEmailPh: 'Neue E-Mail eingeben',
      accountSecurity: 'Kontosicherheit',
      apiKey: 'API-Schlüssel',
      notGenerated: 'Nicht generiert'
    },
	chatSettings: {
	  title: 'Chat-Einstellungen',
	  avatar: 'Chat-Avatar',
	  avatarTip: 'Empfohlene Größe: 200x200. Unterstützt JPG/PNG. Max. 5 MB.',
	  channelName: 'Chat-Name',
	  channelNamePlaceholder: 'Geben Sie den Anzeigenamen für den Chat ein',
	  welcomeMsg: 'Standard-Willkommensnachricht',
	  welcomeMsgPlaceholder: 'Willkommensnachricht, die automatisch gesendet wird, wenn ein Besucher den Chat betritt',
	  save: 'Einstellungen speichern',
	  saving: 'Wird gespeichert...',
	  saveSuccess: 'Erfolgreich gespeichert',
	  saveFailed: 'Speichern fehlgeschlagen'
	},
    chatPlan: {
      title: 'Chat-Tarife',
      currentPlan: 'Aktueller Tarif',
      perMonth: '/Monat',
      seats: 'Agenten',
      seatsUnit: '',
      maxSessions: 'Max. Sitzungen',
      expiryTime: 'Ablauf',
      daysLeft: '({0} Tage verbleibend)',
      autoRenew: 'Automatisch verlängern',
      btnRenew: 'Jetzt verlängern',
      btnUpgrade: 'Upgrade',
      plansTitle: 'Tarife',
      recommended: 'Empfohlen',
      current: 'Aktuell',
      selectPlan: 'Tarif auswählen',
      renewalTitle: 'Verlängerungsverlauf',
      thOrderId: 'Bestell-ID',
      thPlan: 'Tarif',
      thAmount: 'Betrag',
      thPayment: 'Zahlung',
      thDuration: 'Dauer',
      thExpiry: 'Ablauf',
      thStatus: 'Status',
      renewModalTitle: 'Tarif verlängern',
      month: '{0} Monate',
      discount10: '10% RABATT',
      discount7: '30% RABATT',
      confirmRenew: 'Verlängerung bestätigen',
      renewSuccess: 'Verlängert! {0} Monate verlängert',
	  kaiqiok: 'Erfolgreich aktiviert',
	  guanbiok: 'Erfolgreich deaktiviert',
      renewFailed: 'Verlängerung fehlgeschlagen',
      retryLater: 'Bitte versuchen Sie es erneut',
      switchSuccess: 'Gewechselt zu {0}',
      switchFailed: 'Wechsel fehlgeschlagen'
    },
    chatManage: {
      sessionList: 'Sitzungen',
      sessionCount: '{0} Sitzungen',
      searchVisitor: 'Besucher suchen...',
      online: 'Online',
      offline: 'Offline',
      source: 'Quelle:',
      btnTransfer: 'Übertragen',
      btnEndSession: 'Sitzung beenden',
      btnEnd: 'Beenden',
      inputPlaceholder: 'Nachricht eingeben...',
      send: 'Senden',
      me: 'Ich',
      selectSession: 'Sitzung auswählen zum Chatten',
      emoji: 'Emoji',
      file: 'Datei'
    },
    receptionRecords: {
      title: 'Empfangsdaten',
      allStatus: 'Alle Status',
      completed: 'Abgeschlossen',
      ongoing: 'Laufend',
      missed: 'Verpasst',
      searchVisitor: 'Besuchernamen suchen...',
      visitor: 'Besucher',
      source: 'Quelle',
      agent: 'Agent',
      startTime: 'Startzeit',
      endTime: 'Endzeit',
      messages: 'Nachrichten',
      satisfaction: 'Zufriedenheit',
      status: 'Status',
      action: 'Aktion',
      view: 'Anzeigen',
      notRated: 'Nicht bewertet',
      totalRecords: '{0} Einträge',
      prevPage: 'Zurück',
      nextPage: 'Weiter',
      detailTitle: 'Sitzungsdetails',
      visitorEmail: 'Besucher-E-Mail:',
      sourceLabel: 'Quelle:',
      agentLabel: 'Agent:',
      durationLabel: 'Dauer:',
      minute: 'Min.'
    },
    agentManage: {
      title: 'Agentenverwaltung',
      addAgent: 'Agent hinzufügen',
      agent: 'Agent',
      account: 'Konto',
      status: 'Status',
      currentSessions: 'Aktiv',
      lastOnline: 'Zuletzt online',
      action: 'Aktion',
      online: 'Online',
      offline: 'Offline',
      enable: 'Aktivieren',
      disable: 'Deaktivieren',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      loading: 'Wird geladen...',
      empty: 'Noch keine Agenten, oben rechts auf Hinzufügen klicken',
      addTitle: 'Agent hinzufügen',
      editTitle: 'Agent bearbeiten',
      nameLabel: 'Agentenname',
      namePlaceholder: 'z.B. Support Zhang',
      accountLabel: 'Anmeldekonto',
      accountPlaceholder: 'z.B. kefu1',
      passwordLabel: 'Anmeldekennwort',
      passwordPlaceholder: 'Mindestens 6 Zeichen',
      resetPasswordLabel: 'Kennwort zurücksetzen (leer lassen, um zu behalten)',
      resetPasswordPlaceholder: 'Leer lassen, um das aktuelle Kennwort beizubehalten',
      statusLabel: 'Status',
      cancel: 'Abbrechen',
      saving: 'Wird gespeichert...',
      save: 'Speichern',
      nameRequired: 'Bitte Agentennamen eingeben',
      passwordMin: 'Das Kennwort muss mindestens 6 Zeichen lang sein',
      accountRequired: 'Bitte Anmeldekonto eingeben',
      saveSuccess: 'Erfolgreich gespeichert',
      saveFailed: 'Speichern fehlgeschlagen',
      opFailed: 'Vorgang fehlgeschlagen',
      networkError: 'Netzwerkfehler, bitte später erneut versuchen',
      deleteSuccess: 'Erfolgreich gelöscht',
      deleteFailed: 'Löschen fehlgeschlagen',
      toggleConfirm: 'Möchten Sie den Agent "{1}" wirklich {0}?',
      deleteConfirm: 'Möchten Sie den Agent "{0}" wirklich löschen? Dies kann nicht rückgängig gemacht werden!'
    }
  },
  help: {
    title: 'Hilfeseite',
    subtitle: 'Anleitungen zur Nutzung der SMS-Man Dienste und Antworten auf häufige Fragen',
    popularQuestions: 'Häufige Fragen',
    q1: 'Wie lange auf SMS warten nach der Registrierung?',
    q1a: 'Die SMS-Wartezeit beträgt maximal 5 Minuten. Wenn Sie keine SMS erhalten, stornieren Sie Ihre Nummer und kaufen Sie eine andere.',
    q2: 'Wie viele SMS kann ich empfangen?',
    q3: 'Was ist der Mindestaufladebetrag?',
    q4: 'Wenn der gewünschte Dienst nicht in der Liste ist, kann ich trotzdem SMS empfangen?',
    q5: 'SMS nicht erhalten, was soll ich tun?',
    q6: 'Was bedeutet "Dienst vorübergehend nicht verfügbar"?',
    q7: 'Wo finde ich meinen API-Schlüssel?',
    q8: 'Wie können Sie mit uns verdienen?',
    serviceGuide: 'Dienstanleitung',
    serviceGuideTitle: 'Wie registriere ich mich online?',
    serviceGuideDesc: 'Konto registrieren, Telefonnummer eingeben, Land auswählen, Dienst auswählen, kaufen klicken, auf SMS warten.',
    howToRent: 'Wie für meinen Dienst mieten?',
    howToRentDesc: 'Dienst auswählen, Land auswählen, Mietdauer auswählen, mieten klicken.',
    howToBuy: 'Wie einmalige SMS kaufen?',
    howToBuyDesc: 'Dienst auswählen, Land auswählen, SMS kaufen klicken.',
    howToUseNumber: 'Wie meine gemietete Nummer nutzen?',
    howToUseNumberDesc: 'Nummer von der Bestellseite kopieren, auf der Zielwebsite eingeben, auf SMS warten.',
    footer: {
      smsPlatform: 'SMS-Plattform',
      rentNumber: 'Nummer mieten',
      apiConnection: 'API',
      referral: 'Empfehlung',
      partnership: 'Partnerschaft',
      partners: 'Partner',
      blog: 'Teilen',
      help: 'Hilfe',
      privacyPolicy: 'Datenschutzrichtlinie',
      termsOfUse: 'Nutzungsbedingungen',
      paymentRefund: 'Zahlung & Rückerstattung',
      companyInfo: 'VtoTop Company Limited',
      address: 'Room B, 10/F, Yue Cheong Building, 38 Des Voeux Road Central, Central, Hong Kong',
      email: 'vtoptopcom@gmail.com'
    }
  },
  blog: {
    title: 'Artikelzentrum',
    recentPosts: 'Neueste Beiträge',
    archives: 'Archiv',
    readMore: 'Weiterlesen',
    comments: 'Aufrufe',
    category: 'Kategorie',
    currentCategory: 'Aktuelle Kategorie:',
    clearFilter: '✕ Filter löschen',
    allCategories: 'Alle Kategorien',
    articleCategories: 'Kategorien'
  },
  articleDetail: {
    loading: 'Laden...',
    notFound: 'Artikel nicht gefunden',
    backToList: '← Zurück zur Artikelübersicht',
    home: 'Startseite',
    blog: 'Teilen',
    views: 'Aufrufe',
    share: 'Teilen:',
    relatedArticles: 'Verwandte Artikel'
  },
  homeApi: {
    title: 'Für Entwickler',
    subtitle: 'API-Dokumentation für die Verbindung Ihrer Dienste mit SMS-Man und automatischem Nummernkauf',
    legacyApi: 'Legacy-API',
    apiV2: 'API 2.0',
    miniApi: 'Mini-API',
    apiDesc: 'Die API-Schnittstelle ermöglicht es Ihnen, automatisch SMS von SMS-Man zu kaufen und zu empfangen. Dienste werden automatisch synchronisiert.',
    getBalance: 'Guthaben abfragen',
    getBalanceDesc: 'Aktuelles Kontoguthaben abfragen',
    params: 'Parameter',
    field: 'Feld',
    type: 'Typ',
    required: 'Erforderlich',
    value: 'Wert',
    result: 'Ergebnis',
    possibleErrors: 'Mögliche Fehler',
    rateLimit: 'Rate-Limit',
    getNumber: 'Nummer erhalten',
    getNumberDesc: 'Nummer für das angegebene Land erhalten, country_id angeben',
    getSms: 'SMS erhalten',
    getSmsDesc: 'SMS für die angegebene Bestellung erhalten',
    setStatus: 'Status setzen',
    setStatusDesc: 'Bestellstatus ändern',
    getCountries: 'Länderliste abrufen',
    getCountriesDesc: 'Alle verfügbaren Länder abrufen',
    getServices: 'Dienstliste abrufen',
    getServicesDesc: 'Alle verfügbaren Dienste abrufen'
  },
  onlineSms: {
    hero: {
      title: 'Online-SMS-Verifizierungsplattform',
      desc: 'Registrieren Sie sich bei sozialen Netzwerken und Online-Shops ohne Spam oder Offenlegung persönlicher Daten.',
      viewNumbers: 'Nummern anzeigen',
      receiveCode: 'Code empfangen'
    },
    countries: {
      title: 'Land/Region auswählen',
      subtitle: 'Wählen Sie aus über 200 Ländern eine virtuelle Nummer für SMS-Verifizierung',
      services: 'Dienste',
      select: 'Auswählen'
    },
    services: {
      title: 'Beliebteste Dienste heute',
      buy: 'Kaufen'
    },
    howItWorks: {
      title: 'Virtuelle Nummer in 3 Schritten mieten',
      subtitle: 'So funktioniert es',
      step1Title: 'Land auswählen',
      step1Desc: 'Wählen Sie das Land für Ihre virtuelle Nummer aus über 200 Optionen',
      step2Title: 'Dienst auswählen',
      step2Desc: 'Wählen Sie die App oder den Dienst, von dem Sie SMS empfangen möchten',
      step3Title: 'SMS empfangen',
      step3Desc: 'Virtuelle Nummer erhalten und Verifizierungscodes online empfangen'
    },
    features: {
      fastTitle: 'Schnelle Verifizierung',
      fastDesc: 'Verifizierungscodes in Sekunden erhalten, kein Warten',
      safeTitle: 'Datenschutz',
      safeDesc: 'Virtuelle Nummern zum Schutz Ihrer Privatsphäre',
      globalTitle: 'Globale Abdeckung',
      globalDesc: 'Unterstützung von Diensten in über 200 Ländern'
    },
    cta: {
      title: 'Jetzt registrieren und verifizieren',
      desc: 'Erhalten Sie kostenlose Credits bei der Registrierung und testen Sie unseren virtuellen Nummerndienst',
      register: 'Kostenlos registrieren'
    },
    faq: {
      title: 'Häufig gestellte Fragen',
      q1: 'Was ist Online-SMS-Verifizierung?',
      a1: 'Online-SMS-Verifizierung ist ein Dienst, der virtuelle Nummern verwendet, um SMS-Verifizierungscodes zu empfangen.',
      q2: 'Wie lange kann ich eine Nummer nutzen?',
      a2: 'Je nach Dienst können Nummern von 20 Minuten bis 30 Tage genutzt werden.',
      q3: 'Wie wird die Privatsphäre geschützt?',
      a3: 'Alle Nummern sind virtuell und werden nach der Nutzung gelöscht.'
    }
  },
  esim: {
    hero: {
      title: 'eSIM online kaufen',
      desc: 'Globale mobile Daten sofort erhalten. Aktivieren Sie Ihre eSIM per QR-Code in Sekunden.',
      learnMore: 'Mehr erfahren',
      countries: 'Länder',
      network: 'Netzwerk',
      activation: 'Aktivierung'
    },
    howItWorks: {
      title: 'In drei einfachen Schritten verbunden',
      step1Title: 'Tarif auswählen',
      step1Desc: 'Wählen Sie das Land/die Region und den Datentarif',
      step2Title: 'Bezahlen & QR-Code erhalten',
      step2Desc: 'Nach der Zahlung erhalten Sie einen eSIM-Aktivierungs-QR-Code',
      step3Title: 'Scannen & Loslegen',
      step3Desc: 'QR-Code in Ihren Telefoneinstellungen scannen um eSIM zu aktivieren'
    },
    whyEsim: {
      title: 'Warum eSIM',
      subtitle: 'Eine smartere Art, im Ausland verbunden zu bleiben',
      f1Title: 'Keine Roaming-Gebühren',
      f1Desc: 'Lokale Mobilfunknetze nutzen und teure internationale Roaming-Gebühren vermeiden',
      f2Title: 'Sofortige Aktivierung',
      f2Desc: 'Aktivierung durch Scannen des QR-Codes, kein Warten auf physische SIM-Karte',
      f3Title: 'Haupt-SIM behalten',
      f3Desc: 'Hauptnummer weiter nutzen während eSIM für Daten verwendet wird'
    },
    cta: {
      title: 'Bereit für Reisen ohne Roaming-Gebühren?',
      desc: 'Aktivieren Sie Ihre eSIM in Minuten und bleiben Sie weltweit verbunden'
    },
    comparison: {
      title: 'eSIM vs. lokale SIM-Karte',
      r1: 'Vor der Reise einrichten',
      r2: 'Sofortige Aktivierung',
      r3: 'Kein Kartenwechsel',
      r4: 'Hauptnummer behalten',
      r5: 'Fester, vorhersehbarer Preis',
      r6: 'Anmeldung nur per E-Mail',
      r7: 'Krypto akzeptiert'
    },
    plus: {
      title: 'eSIM plus alles, was SMS-MAN bereits bietet',
      desc: 'Kombinieren Sie Ihren Datentarif mit virtuellen Nummern und SMS-Verifizierung — alles unter einem Konto'
    },
    faq: {
      title: 'Fragen zu eSIM',
      q1: 'Was ist eine eSIM und wie funktioniert sie?',
      a1: 'Eine eSIM ist eine eingebettete SIM-Karte, die mobile Daten ohne physische Karte aktiviert.',
      q2: 'Welche Geräte unterstützen SMS-MAN eSIM?',
      a2: 'Die meisten modernen Smartphones unterstützen eSIM, einschließlich iPhone XS und neuer, Samsung Galaxy S20 und neuer.',
      q3: 'Wie schnell ist die Aktivierung?',
      a3: 'Normalerweise nur Sekunden — QR-Code scannen und loslegen.',
      q4: 'Ersetzt meine eSIM meine Hauptnummer?',
      a4: 'Nein, eSIM ist nur für Daten. Ihre Hauptnummer bleibt gleich.',
      q5: 'Kann ich später Daten aufladen oder nachkaufen?',
      a5: 'Ja, Sie können jederzeit zusätzliche Datenpakete über Ihr Konto kaufen.'
    }
  },
  agent: {
    hero: {
      title: 'SMS-MAN Agent werden',
      desc: 'Verdienen Sie Provisionen durch die Bewerbung von SMS-MAN Diensten.',
      becomeAgent: 'Agent werden',
      learnMore: 'Mehr erfahren'
    },
    benefits: {
      title: 'Agent-Vorteile',
      subtitle: 'Warum SMS-MAN Agent werden',
      b1Title: 'Hohe Provision',
      b1Desc: 'Bis zu 20% Empfehlungsprovision verdienen',
      b2Title: 'Passives Einkommen',
      b2Desc: 'Provisionen verdienen, solange Ihre Empfehlungen weiter ausgeben',
      b3Title: 'Dedizierter Support',
      b3Desc: 'Exklusiver Agent-Kontomanager für schnelle Problemlösung',
      b4Title: 'Globaler Markt',
      b4Desc: 'Ohne geografische Einschränkungen weltweit bewerben'
    },
    howItWorks: {
      title: 'So fangen Sie an',
      step1Title: 'Konto registrieren',
      step1Desc: 'SMS-MAN Konto erstellen und als Agent bewerben',
      step2Title: 'Empfehlungslink erhalten',
      step2Desc: 'Ihren einzigartigen Empfehlungslink und Marketing-Materialien erhalten',
      step3Title: 'Provision verdienen',
      step3Desc: 'Provision verdienen, wenn sich Benutzer über Ihren Link registrieren und ausgeben'
    },
    commission: {
      title: 'Provisionsstufen',
      l1Name: 'Junior-Agent',
      l1Desc: '1-50 empfohlene Benutzer pro Monat',
      l2Name: 'Mid-Agent',
      l2Desc: '51-200 empfohlene Benutzer pro Monat',
      l3Name: 'Senior-Agent',
      l3Desc: '200+ empfohlene Benutzer pro Monat'
    },
    features: {
      title: 'Agent-Tools',
      f1Title: 'Dashboard',
      f1Desc: 'Echtzeit-Ansicht der Empfehlungsdaten und Provisionsübersicht',
      f2Title: 'Empfehlungslink',
      f2Desc: 'Einzigartiger Empfehlungslink mit genauer Konversionsverfolgung',
      f3Title: 'Schnelle Auszahlung',
      f3Desc: 'Provisionen jederzeit auf verschiedene Zahlungsmethoden abheben',
      f4Title: 'Dedizierter Support',
      f4Desc: 'Exklusiver Agent-Support-Channel mit Prioritätsbehandlung'
    },
    cta: {
      title: 'Bereit loszulegen?',
      desc: 'Jetzt registrieren und SMS-MAN Agent werden',
      joinNow: 'Jetzt beitreten'
    }
  },
  softwareDev: {
    heroTitle: 'Professionelle Softwareentwicklung',
    heroDesc: 'Von der Anforderungsanalyse bis zur Auslieferung bieten wir Full-Stack-Entwicklungslösungen.',
    btnViewCases: 'Fälle ansehen',
    btnContact: 'Kontaktieren Sie uns',
    servicesTitle: 'Dienste',
    servicesSubtitle: 'Umfassende Softwareentwicklungsdienste für vielfältige Geschäftsanforderungen',
    service1Title: 'Webanwendungsentwicklung',
    service1Desc: 'Full-Stack-Entwicklung für Unternehmenswebsites, E-Commerce-Plattformen, SaaS-Systeme',
    service2Title: 'Mobile App-Entwicklung',
    service2Desc: 'Native iOS/Android-Apps und plattformübergreifende Entwicklung mit React Native/Flutter',
    service3Title: 'API-Entwicklung',
    service3Desc: 'RESTful-APIs, WebSocket-Echtzeitkommunikation und Drittsystemintegration',
    service4Title: 'Automatisierungssysteme',
    service4Desc: 'Datenerfassung, Automatisierungsskripte, geplante Aufgaben und Geschäftsprozessautomatisierung',
    service5Title: 'Gaming/Unterhaltungssysteme',
    service5Desc: 'Kartenspiele, Lotteriesysteme, Instant Messaging und Echtzeit-Interaktionsplattformen',
    service6Title: 'Cloud-Bereitstellung',
    service6Desc: 'Serverbereitstellung, CI/CD-Pipelines, Docker-Containerisierung und Leistungsoptimierung',
    techStackTitle: 'Technologie-Stack',
    casesTitle: 'Projektbeispiele',
    casesSubtitle: 'Ausgelieferte Projekte',
    projectShare: 'Teilen',
    processTitle: 'Entwicklungsprozess',
    process1Title: 'Anforderungsbesprechung',
    process1Desc: 'Tiefes Verständnis der Projektanforderungen',
    process2Title: 'Lösungsdesign',
    process2Desc: 'Detaillierte technische Architektur, Datenbankdesign und UI-Prototypen',
    process3Title: 'Entwicklung',
    process3Desc: 'Agile Entwicklung mit regelmäßigen Demos',
    process4Title: 'Testen & Optimieren',
    process4Desc: 'Umfassende Funktions-, Leistungs- und Sicherheitstests',
    process5Title: 'Bereitstellung',
    process5Desc: 'Serverbereitstellung, Domain-Konfiguration, SSL-Zertifikate',
    process6Title: 'Wartung & Support',
    process6Desc: 'Kontinuierlicher technischer Support und Fehlerbehebungen',
    stats1Label: 'Ausgelieferte Projekte',
    stats2Label: 'Zufriedene Kunden',
    stats3Label: 'Jahre Erfahrung',
    stats4Label: 'Kundenzufriedenheit',
    contactTitle: 'Haben Sie ein Projekt?',
    contactDesc: 'Erzählen Sie uns Ihre Ideen, und wir bieten professionelle Entwicklungslösungen',
    contactOnline: 'Online-Support',
    contactBtn: 'Jetzt beraten'
  },
  lotteryPage: {
    heroTitle: 'Live-Lotterieziehungszentrum',
    heroDesc: 'Mehrere Lotterien mit Sofortziehungen, Echtzeit-Datensynchronisierung, fair und transparent',
    statLottery: 'Lotterietypen',
    statNonStop: 'Nonstop-Ziehungen',
    statSync: 'Echtzeit-Sync',
    periodDraw: 'Ziehung #{0}',
    currentRemain: 'Aktuell {0}, verbleibend {1}',
    dragonTiger: '1-5 Drache/Tiger',
    championSum: 'Champion-Summe',
    betNow: 'Jetzt wetten',
    tabHistory: 'Verlauf',
    tabRoad: 'Straßenanalyse',
    tabHotCold: 'Heiß/Kalt',
    tabTrend: 'Champion-Trend',
    rulesTitle: 'Regeln',
    rule1Title: 'Drache/Tiger',
    rule1Desc: 'Vergleichen Sie die erste und letzte gezogene Nummer.',
    rule2Title: 'Champion-Summe',
    rule2Desc: 'Champion- und Vizenummern addieren, groß/klein und ungerade/gerade bestimmen.',
    rule3Title: 'Groß/Klein Ungerade/Gerade',
    rule3Desc: 'Groß (6-10) oder klein (1-5) und ungerade/gerade bestimmen.',
    rule4Title: 'Straßenanalyse',
    rule4Desc: 'Ziehungsmuster und Trends durch historische Straßenkarten analysieren.',
    dragon: 'Drache',
    tiger: 'Tiger',
    big: 'Groß',
    small: 'Klein',
    odd: 'Ungerade',
    even: 'Gerade',
    countdownMin: 'Min',
    countdownSec: 'Sek',
    nameSpeedRacing: 'Speed Racing',
    nameSgAirship: 'SG Luftschiff',
    nameSpeedAirship: 'Speed Luftschiff',
    nameLuckyAirship: 'Lucky Luftschiff',
    logoRacing: 'Racing',
    logoAirship: 'Luftschiff'
  },
  apiDocs: {
    pageTitle: 'API-Dokumentation',
    pageSubtitle: 'SMS, Lotterieziehung, Kundenservice und andere API-Schnittstellen zur schnellen Integration',
    tabSms: 'SMS-API',
    tabLottery: 'Lotterie-API',
    tabChat: 'Live-Chat-API',
    versionLegacy: 'Legacy-API',
    versionV2: 'API 2.0',
    versionMini: 'Mini-API',
    baseAddress: 'Basis-URL',
    requestMethod: 'Methode',
    returnFormat: 'Antwortformat',
    authMethod: 'Authentifizierung',
    requestParams: 'Anfrageparameter',
    field: 'Feld',
    type: 'Typ',
    required: 'Erforderlich',
    description: 'Beschreibung',
    yes: 'Ja',
    no: 'Nein',
    returnExample: 'Antwortbeispiel',
    smsDesc: 'SMS-API bietet vollständige Funktionen für den virtuellen Nummernkauf, SMS-Empfang und Statusverwaltung.',
    lotteryDesc: 'Lotterie-API bietet Echtzeit-Ziehungsdatenabfragen, Verlauf und Trendanalyse.',
    chatDesc: 'Live-Chat-API bietet Sitzungsverwaltung, Messaging und Agentenverwaltung.',
    ep: {
      getBalance: 'Guthaben abfragen', getNumber: 'Nummer erhalten', getSms: 'SMS erhalten',
      checkBalance: 'Guthaben prüfen', createOrder: 'Bestellung erstellen', querySms: 'SMS abfragen',
      setStatus: 'Status setzen', getCountries: 'Länder abrufen', getServices: 'Dienste abrufen',
      getLotteryList: 'Ziehungsliste abrufen', getLotteryHistory: 'Ziehungsverlauf abrufen',
      getLotteryTypes: 'Lotterietypen abrufen', liveDraw: 'Live-Ziehung',
      lotteryHistory: 'Ziehungsverlauf', lotteryStats: 'Ziehungsstatistik',
      latestDraw: 'Neueste Ziehung', createSession: 'Sitzung erstellen',
      sendMessage: 'Nachricht senden', getMessageHistory: 'Nachrichtenverlauf abrufen',
      agentStatus: 'Agentenstatus', closeSession: 'Sitzung schließen', quickSend: 'Schnellsendung'
    },
    epd: {
      getBalance: 'Aktuelles Kontoguthaben abfragen', getNumber: 'Virtuelle Nummer für SMS-Empfang erhalten',
      getSms: 'SMS-Verifizierungscode für eine Nummer erhalten', checkBalance: 'Aktuelles verfügbares Guthaben abrufen',
      createOrder: 'SMS-Bestellung erstellen und virtuelle Nummer erhalten', querySms: 'Abfragen um Bestell-SMS-Inhalt zu erhalten',
      setStatus: 'Bestellstatus setzen (erhalten/abbrechen/fortsetzen)',
      getCountries: 'Alle unterstützten Länder abrufen', getServices: 'Alle unterstützten SMS-Dienste abrufen',
      getLotteryList: 'Neueste Ziehungsinfo für alle Lotterien abrufen', getLotteryHistory: 'Ziehungsverlauf für einen Lotterietyp abrufen',
      getLotteryTypes: 'Alle unterstützten Lotterietypen abrufen', liveDraw: 'Neuestes Ziehungsergebnis für eine Lotterie abrufen',
      lotteryHistory: 'Ziehungsverlauf mit Paginierung abrufen', lotteryStats: 'Ziehungsstatistik abrufen (heiße/kalte Nummern)',
      latestDraw: 'Neueste Ziehung für alle Lotterien abrufen (vereinfacht)', createSession: 'Neue Support-Sitzung erstellen',
      sendMessage: 'Nachricht an eine Sitzung senden', getMessageHistory: 'Chat-Verlauf einer Sitzung abrufen',
      agentStatus: 'Online-Agentenliste und Status abrufen', closeSession: 'Bestimmte Sitzung schließen',
      quickSend: 'Sitzung erstellen und Nachricht in einem Aufruf senden',
      getNumberSimple: 'Nummer mit einem Klick erhalten (vereinfacht)', getSmsSimple: 'SMS-Inhalt erhalten',
      createSessionV2: 'Support-Sitzung mit automatischer Agentenzuweisung erstellen', sendMessageV2: 'Nachricht an eine bestimmte Sitzung senden'
    }
  },
  liveChat: {
    heroTitle: 'Live-Chat-System',
    heroDesc: 'WebSocket-basierte Echtzeit-Kundenservice-Chat-Plattform mit Multi-Agenten-Zusammenarbeit, Smart Routing, Nachrichtenverlauf und Dateiübertragung.',
    btnFreeTrial: 'Kostenlos testen',
	catedengl: 'Kundenservice-Anmeldung',
    btnDemo: 'Desktop-Client herunterladen',
    previewName: 'Agent Wang',
    previewStatus: '● Online',
    previewMsg1: 'Hallo! Wie kann ich Ihnen helfen?',
    previewMsg2: 'Ich möchte mehr über Ihre Dienste erfahren',
    previewMsg3: 'Gerne, lassen Sie mich Ihnen vorstellen...',
    inputPlaceholder: 'Nachricht eingeben...',
    featuresTitle: 'Kernfunktionen',
    featuresSubtitle: 'Umfassende Kundenservice-Lösung zur Verbesserung der Zufriedenheit',
    feature1Title: 'Echtzeit-Nachrichten',
    feature1Desc: 'WebSocket-basierte Millisekunden-Nachrichtenzustellung',
    feature2Title: 'Multi-Agenten-Zusammenarbeit',
    feature2Desc: 'Mehrere Agenten gleichzeitig online mit intelligentem Sitzungs-Routing',
    feature3Title: 'Nachrichtenverlauf',
    feature3Desc: 'Vollständiger Chat-Verlauf mit Suche und Export',
    feature4Title: 'Dateiübertragung',
    feature4Desc: 'Bilder, Dokumente und andere Dateitypen senden und empfangen',
    feature5Title: 'Smart Routing',
    feature5Desc: 'Automatische Kundenzuweisung basierend auf Agentenauslastung',
    feature6Title: 'Analyse & Berichte',
    feature6Desc: 'Echtzeit-Statistiken zu Sitzungen, Antwortzeit, Zufriedenheit',
    stepsTitle: 'Schnelleinrichtung',
    step1Title: 'Konto registrieren',
    step1Desc: 'Administratorkonto erstellen, Firmeninfo konfigurieren',
    step2Title: 'Code einbetten',
    step2Desc: 'Eine Zeile Code auf Ihrer Website einbetten',
    step3Title: 'Service starten',
    step3Desc: 'Agenten melden sich an und empfangen Kunden',
    dashboardTitle: 'Leistungsstarkes Admin-Panel',
    dashboardDesc: 'Echtzeit-Überwachung von Agentenstatus, Sitzungsdaten, Kundenzufriedenheit',
    dashFeature1: 'Echtzeit-Agentenstatus und Sitzungsanzahl',
    dashFeature2: 'Sitzungs-Routing-Regeln und automatische Zuweisung',
    dashFeature3: 'Agentenarbeitszeiten und Leistungsstatistiken',
    dashFeature4: 'Kundenzufriedenheitsbewertungen und Feedback',
    dashFeature5: 'Chat-Verlauf-Suche und Export',
    dashFeature6: 'Benutzerdefinierte Schnellantworten und Wissensdatenbank',
    dashStat1: 'Heutige Sitzungen',
    dashStat2: 'Zufriedenheit',
    dashStat3: 'Ø Antwortzeit',
    dashStat4: 'Online-Agenten',
    pricingTitle: 'Preispläne',
    pricingBadge: 'Empfohlen',
    pricingPeriod: '/Monat',
    btnSelectPlan: 'Tarif auswählen',
    planBasic: 'Basis',
    planPro: 'Professionell',
    planEnterprise: 'Unternehmen',
    ctaTitle: 'Bereit, Ihren Kundenservice zu verbessern?',
    ctaDesc: 'Jetzt registrieren und alle Funktionen kostenlos testen',
    ctaBtn: 'Kostenlos starten',
    pf1Basic: '1 Agenten', pf2Realtime: 'Echtzeit-Chat', pf3History: 'Nachrichtenverlauf',
    pf4Reports: 'Basisberichte', pf5Email: 'E-Mail-Support',
    pf1Agents: '10 Agenten', pf4AdvReports: 'Erweiterte Berichte', pf5Smart: 'Smart Routing',
    pf6File: 'Dateiübertragung', pf7Priority: 'Prioritäts-Support',
    ef1Unlimited: 'Unbegrenzte Agenten', ef2All: 'Alle Funktionen', ef3Api: 'API-Zugang',
    ef4Private: 'Private Bereitstellung', ef5Dedicated: 'Dedizierter Support', ef6Sla: 'SLA-Garantie'
  },
  apiMsg: {
    userNotFound: 'Diese E-Mail ist nicht registriert', wrongPassword: 'Falsches Passwort', accountDisabled: 'Dieses Konto wurde deaktiviert',
    agentNotFound: 'Agentenkonto existiert nicht', agentDisabled: 'Dieses Agentenkonto wurde deaktiviert',
    notLogin: 'Bitte zuerst anmelden', tokenExpired: 'Sitzung abgelaufen, bitte erneut anmelden',
    emailRequired: 'Bitte E-Mail eingeben', emailInvalid: 'Ungültiges E-Mail-Format',
    emailPasswordRequired: 'E-Mail und Passwort sind erforderlich', accountPasswordRequired: 'Konto und Passwort sind erforderlich',
    agentAccountRequired: 'Agentenkonto und Passwort sind erforderlich',
    passwordMin: 'Das Passwort muss mindestens 6 Zeichen haben', newPasswordMin: 'Das neue Passwort muss mindestens 6 Zeichen haben',
    emailExists: 'Diese E-Mail ist bereits registriert', usernameExists: 'Dieser Benutzername ist bereits vergeben',
    captchaWrong: 'Falscher Bestätigungscode', captchaExpired: 'Code abgelaufen, bitte neuen anfordern',
    paramError: 'Ungültige Parameter', paramIncomplete: 'Bitte alle Felder ausfüllen', missingId: 'ID fehlt',
    nothingToUpdate: 'Keine zu aktualisierenden Angaben', invalidStatus: 'Ungültiger Statuswert', indexOutOfRange: 'Index außerhalb des Bereichs',
    missingChannelCode: 'Kanal-Code fehlt', channelNotFound: 'Kanal nicht gefunden', channelClosed: 'Dieser Kanal ist geschlossen',
    noChatChannel: 'Dieses Mitglied hat keinen Support-Kanal aktiviert', chatPlanExpired: 'Das Support-Paket ist abgelaufen und nicht nutzbar',
    noAgentOnlineRetry: 'Derzeit ist kein Agent online, bitte später erneut versuchen',
    targetAgentInvalid: 'Zielagent existiert nicht oder ist deaktiviert', agentNoOperate: 'Agent nicht vorhanden oder keine Berechtigung',
    sessionNotFound: 'Sitzung nicht gefunden', sessionMismatch: 'Sitzung stimmt nicht überein',
    noPermissionTransfer: 'Sie dürfen diese Sitzung nicht weiterleiten', noPermissionClose: 'Sie dürfen diese Sitzung nicht beenden',
    noPermissionDelete: 'Sie dürfen diese Sitzung nicht löschen',
    chatHasHistory: 'Die Sitzung enthält Chatverlauf und kann nicht gelöscht werden', clientOnline: 'Kunde ist online, Löschen nicht möglich',
    onlyAgentRecall: 'Nur Agenten-Nachrichten können zurückgerufen werden',
    balanceInsufficient: 'Guthaben reicht nicht aus', rechargeMinAmount: 'Der Mindestbetrag für die Aufladung beträgt 1 USD',
    orderNotFound: 'Bestellung nicht gefunden', orderCancelled: 'Diese Bestellung ist bereits storniert', orderConfirmed: 'Diese Zahlung ist bereits bestätigt',
    orderNotPayable: 'Der Bestellstatus erlaubt diesen Vorgang nicht',
    planNotFound: 'Paket nicht gefunden', serviceNotFound: 'Dienst nicht gefunden', articleNotFound: 'Artikel nicht gefunden',
    numberUnavailable: 'Diese Nummer ist nicht verfügbar', noAvailableNumber: 'Keine Nummer verfügbar',
    numberExists: 'Diese Nummer existiert bereits', rentalNotFound: 'Mietdatensatz nicht gefunden',
    agentLimitReached: 'Das Agentenlimit Ihres Pakets ist erreicht', emailSendFailed: 'E-Mail konnte nicht gesendet werden, bitte später erneut versuchen'
  },
  clientDownload: {
    badge: 'Offizieller Desktop-Client',
    heroTitle: 'Kundenservice-Client herunterladen',
    heroDesc: 'Ein Desktop-Client speziell für Service-Mitarbeiter: mehrere Sitzungen gleichzeitig bearbeiten, Nachrichten in Echtzeit, Schnellantworten und Weiterleitung – so betreut Ihr Team jeden Kunden effizient.',
    winDownload: 'Windows-Version herunterladen',
    winHint: 'Windows 10 / 11',
    macDownload: 'macOS-Version herunterladen',
    macHint: 'macOS 10.15 oder neuer',
    previewAlt: 'Vorschau des Kundenservice-Clients',
    notice: 'Nach dem Download einfach entpacken und starten – keine Installation nötig. Meldet das System einen unbekannten Entwickler, erlauben Sie den Start bitte in den Systemeinstellungen.',
    featuresTitle: 'Kernfunktionen des Clients',
    featuresSubtitle: 'Ein Desktop-Tool für hohes Nachrichtenaufkommen – stabiler und schneller als die Web-Version',
    f1Title: 'Mehrere Sitzungen verwalten',
    f1Desc: 'Die Sitzungsliste links aktualisiert sich in Echtzeit, ungelesene Nachrichten werden hervorgehoben – kein Kunde geht verloren.',
    f2Title: 'Nachrichten in Echtzeit',
    f2Desc: 'Über eine dauerhafte WebSocket-Verbindung erreichen Besuchernachrichten Sie in Millisekunden, mit automatischer Wiederverbindung.',
    f3Title: 'Schnellantworten',
    f3Desc: 'Häufige Textbausteine mit einem Klick senden – weniger Tippen, deutlich schnellere Antworten.',
    f4Title: 'Weiterleitung & Zusammenarbeit',
    f4Desc: 'Sitzungen lassen sich an andere Mitarbeiter weiterleiten, damit das Team komplexe Fälle gemeinsam löst.',
    stepsTitle: 'In drei Schritten starten',
    s1Title: 'Herunterladen und entpacken',
    s1Desc: 'Wählen Sie die Windows- oder macOS-Version und starten Sie die App nach dem Entpacken direkt.',
    s2Title: 'Mit dem Mitarbeiterkonto anmelden',
    s2Desc: 'Melden Sie sich mit dem im Kundenbereich erstellten Service-Konto an – die Sitzungen Ihres Kanals werden automatisch geladen.',
    s3Title: 'Kunden betreuen',
    s3Desc: 'Besuchernachrichten kommen in Echtzeit an, Schnellantworten und Weiterleitung beschleunigen den Service.',
    ctaTitle: 'Noch kein Service-Konto?',
    ctaDesc: 'Erstellen Sie im Kundenbereich ein Mitarbeiterkonto und starten Sie sofort.',
    ctaBtn: 'Zum Kundenbereich'
  },
  visitorChat: {
    noAgentOnline: 'Derzeit ist kein Agent online. Ihre Nachrichten werden beantwortet, sobald ein Agent online ist.',
    online: 'Online',
    offline: 'Offline',
    connecting: 'Verbindung wird hergestellt...',
    defaultTitle: 'Online-Kundenservice',
    defaultWelcome: 'Hallo! Willkommen beim Online-Kundenservice. Wie können wir Ihnen helfen?',
    channelNotFound: 'Kanal existiert nicht oder ist geschlossen',
    loadError: 'Laden fehlgeschlagen, bitte versuchen Sie es später erneut',
    imageTooLarge: 'Bildgröße darf 2 MB nicht überschreiten',
    sendImage: 'Bild senden',
    inputPlaceholder: 'Nachricht eingeben...',
    supportSuffix: ' Kundenservice'
  }
}
